// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LnB2","select":"styles_select__1OMG8"};